/**
 * Get cookie
 * @param {string} cookieName - The name of the cookie to get
 * @returns {string} - The value of the cookie
 */
export function getCookie(cookieName: string): string | undefined {
  const cookies = document.cookie.split(';');
  let foundValue;

  cookies.forEach((cookie) => {
    const [name, value] = cookie.trim().split('=');
    if (name === cookieName) {
      foundValue = decodeURIComponent(value);
    }
  });

  return foundValue;
}
